export const ENDPOINT_TYPES = {
    SLACK_CHANNEL: 'slack_channel',
    SLACK_USER: 'slack_user',
    WEBHOOK: 'webhook',
    PHONE: 'phone',
    MS_TEAMS_CHANNEL: 'ms_teams_channel',
    MS_TEAMS_USER: 'ms_teams_user',
    TELEGRAM_CHAT: 'telegram_chat',
    WEBEX_ROOM: 'webex_room',
    WEBEX_PERSON: 'webex_person',
    LINE_USER: 'line_user',
    PAGERDUTY_SERVICE: 'pagerduty_service',
    OPSGENIE_INTEGRATION: 'opsgenie_integration',
    TOOL_WEBHOOK: 'tool_webhook',
};
/** Opsgenie GenieKey wire shape: 8-4-4-4-12 segments; segments may include non-hex letters. */
export const OPSGENIE_API_KEY_PATTERN = /^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$/;
export function isValidOpsgenieApiKey(value) {
    return OPSGENIE_API_KEY_PATTERN.test(value);
}
//# sourceMappingURL=channel-endpoint.js.map